// frontend/src/components/common/ScrollToTop.js
import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import { useCompare } from '../../context/CompareContext';

function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const { compareList } = useCompare();

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Dynamic Positioning:
  // If Compare Bar is active (list > 0), move up to bottom-24 (approx 96px)
  // If Compare Bar is inactive, sit at bottom-6 (approx 24px)
  const bottomClass = compareList.length > 0 ? 'bottom-24' : 'bottom-6';

  return (
    <button 
      onClick={scrollToTop}
      className={`fixed ${bottomClass} right-6 z-[9999] 
                 flex items-center justify-center 
                 w-12 h-12 rounded-full 
                 shadow-2xl border-2 border-white
                 transition-all duration-300 ease-in-out
                 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}`}
      aria-label="Scroll to top"
      // FORCE INLINE STYLES TO GUARANTEE VISIBILITY
      style={{ 
          backgroundColor: '#000000', 
          color: '#ffffff',
          boxShadow: '0 4px 6px rgba(0,0,0,0.3)'
      }}
    >
      <FaArrowUp size={18} />
    </button>
  );
}

export default ScrollToTop;